import { TipoAutorizacaoPortariaEnum } from "core/features/portaria/enums";
import { RelatorioBaseData } from "core/features/relatorios/typings";
export interface PortariaAutorizacaoFilter {
  dataInicio: string | null;
  dataFim: string | null;
  search: string | null;
  tipoAutorizacaoId: string | null;
  page?: number;
  limit?: number;
  unidadeId?: string | null;
  pessoaId?: string | null;
}

export type RelatorioPortariaFilter = Omit<
  PortariaAutorizacaoFilter,
  "page" | "limit" | "search"
>;

export enum StatusAutorizacaoPortaria {
  Ativo = "ativo",
  Cancelado = "cancelado",
  Confirmado = "confirmado",
}
export interface AutorizacaoItem {
  id: string;
  eventoId: string;
  tenantId?: string;
  createdAt?: string;
  unidade: {
    id: string;
    numero: string;
    blocoQuadra: {
      id: string;
      nome: string;
    };
  };
  morador: {
    id: string;
    nome: string;
    telefone?: string;
  };
  pessoa: {
    id: string;
    nome: string;
    imagemUrl: string;
    documento: string | null;
    cnh?: string | null;
  };
  quantidadePessoas: number;
  dataInicio: string;
  dataFim: string;
  horaEvento: string | null;
  observacao: string | null;
  tipoAutorizacao: { id: TipoAutorizacaoPortariaEnum; nome: string };
  foto?: string | null;
  documento?: string | null;
  status: StatusAutorizacaoPortaria;
}

export interface NumeroMensagemTipoDestinoResponse {
  numeroMensagens: number;
}

export interface ListaConvidadosPortaria {
  id: string;
  nome: string;
  imagemUrl: string;
  documento: string | null;
  cnh?: string | null;
  lastLogDate?: string | null;
}

export interface TipoAutorizacaoPortariaParametroItem {
  id: string;
  nome: string;
  limiteDias: number | null;
}

export interface DadosPessoaPortaria {
  foto?: string | null;
  imagemDocumento?: string | null;
  documento?: string | null;
  cnh?: string | null;
  placa?: string | null;
}

export interface ConfirmarDadosPortariaForm {
  pessoaExistente?: "1" | "0";
  arquivoFoto?: File;
  arquivoDocumento?: File;
  pessoaId?: string;
  nome?: string;
  placa?: string;
  cnh?: string;
  documento?: string;
}
export interface RelatorioPortariaItem {
  id: string;
  unidade: {
    id: string;
    numero: string;
  };
  blocoQuadra: {
    id: string;
    nome: string;
  } | null;
  pessoa: {
    id: string;
    nome: string;
  };
  pessoaResponsavel: {
    id: string;
    nome: string;
  };
  pessoaAcao: {
    id: string;
    nome: string;
  } | null;
  data: string;
}

export interface RelatorioPortariaResponse {
  items: RelatorioPortariaItem[];
}

export type RelatorioPortariaPdfResponse = RelatorioPortariaResponse &
  RelatorioBaseData;
